import {

} from './../selectors';

import {
  WORKFLOWS_API_CONFIGURE,
  WORKFLOWS_FETCH_START,
  WORKFLOWS_FETCH_API,
  WORKFLOWS_CREATE_START,
  WORKFLOWS_CREATE_API,
  WORKFLOWS_UPDATE_START,
  WORKFLOWS_UPDATE_API,
  STATES_UPDATE_START,
  STATES_UPDATE_API,
  WORKFLOWS_CREATE_API_FULFILLED,
} from '../actions';

/**
 * workflowsApi instance:
 */

export default (workflowsApi) => {
  return store => next => action => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case WORKFLOWS_API_CONFIGURE:
        workflowsApi.setConfig(action.payload);
        break;
      case WORKFLOWS_CREATE_API_FULFILLED:
      case WORKFLOWS_FETCH_START: {
        store.dispatch({
          type: WORKFLOWS_FETCH_API,
          payload: workflowsApi.getWorkflows(),
        });
        break;
      }
      case WORKFLOWS_CREATE_START: {
        const { type, attributes } = action.payload;

        store.dispatch({
          type: WORKFLOWS_CREATE_API,
          payload: workflowsApi.createWorkflow(type, attributes),
        });
        break;
      }
      case WORKFLOWS_UPDATE_START: {
        const { workflow, attributes } = action.payload;

        store.dispatch({
          type: WORKFLOWS_UPDATE_API,
          payload: workflowsApi.updateWorkflow(workflow, attributes),
        });
        break;
      }
      case STATES_UPDATE_START: {
        const { id, attributes } = action.payload;

        store.dispatch({
          type: STATES_UPDATE_API,
          payload: workflowsApi.updateState(id, attributes),
        });
        break;
      }
    }

    return next(action);
  };
};
